import React, { useState } from "react";
import { Loader } from "../../Common/Loader";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import NativeAppsIntegration from "./Tabs/NativeAppsIntegration";
import IntegrateWithApi from "./Tabs/IntegrateWithApi";
import ZapierIntegration from "./Tabs/ZapierIntegration";
import AutomationTools from "./Tabs/AutomationTools";
import { useSelector } from "react-redux";

const IntegrationTabs = () => {
  const { userPlanFeatures } = useSelector((s) => s?.userPlanDetails);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const isShowNativeIntegration = userPlanFeatures?.CALENDAR_INTEGRATIONS;
  const [selectedTab, setSelectedTab] = useState(
    isShowNativeIntegration ? 1 : 3
  );

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  return (
    <div className="page__body">
      {isLoading ? <Loader /> : ""}
      {errorModal.visible ? <ErrorModel message={errorModal.message} /> : ""}
      {successModal.visible ? (
        <SuccessModel message={successModal.message} />
      ) : (
        ""
      )}

      <div className="tabsWrap">
        <ul className="tabs">
          {isShowNativeIntegration ? (
            <li
              className={
                selectedTab === 1
                  ? "tabs__link tabs__link--selected"
                  : "tabs__link"
              }
              onClick={() => {
                setSelectedTab(1);
              }}
            >
              Native Apps
            </li>
          ) : null}
          <li
            className={
              selectedTab === 3
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(3);
            }}
          >
            Powered by Zapier
          </li>
          <li
            className={
              selectedTab === 4
                ? "tabs__link tabs__link--selected"
                : "tabs__link"
            }
            onClick={() => {
              setSelectedTab(4);
            }}
          >
            Automation Tools
          </li>
        </ul>
      </div>
      {selectedTab == 1 ? (
        <NativeAppsIntegration
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          showSuccessMessage={showSuccessMessage}
          showErrorMessage={showErrorMessage}
        />
      ) : selectedTab === 2 ? (
        <IntegrateWithApi />
      ) : selectedTab == 4 ? (
        <AutomationTools />
      ) : (
        <ZapierIntegration />
      )}
    </div>
  );
};

export default IntegrationTabs;
